class WallpaperItem {
  constructor(el) {
    this._bind();

    this.dom = {
      el: el,

      // Colors
      colors: el.querySelectorAll(".color-container .color"),
      removeableBtn: el.querySelector(".button[data-type='removable']"),
      traditionalBtn: el.querySelector(".button[data-type='traditional']"),
      grassclothBtn: el.querySelector(".button[data-type='grasscloth']"),
      vinylBtn: el.querySelector(".button[data-type='vinyl']"),

      // Images
      images: el.querySelectorAll(".variant-images img"),

      // Overlay Container
      overlayContainer: el.querySelector(".overlay-container"),
      addSampleContainer: el.querySelector(".add-sample-container"),
      optionContainer: el.querySelector(".option-container"),
      sampleButtons: el.querySelectorAll(".option-container span"),
    }

    const selectedColor = el.querySelector(".color-container .color.is-selected") || this.dom.colors[0];
    const selectedColorIndex = Array.from(this.dom.colors).indexOf(selectedColor);

    if (selectedColorIndex >= 0) {
      this.changeImage(selectedColorIndex);
    } else if (this.dom.images[0]) {
      this._hydrateImage(this.dom.images[0]);
      this.dom.images[0].classList.add("active");
    }

    this._addEvents();
  }

  _bind() {
    ['changeImage', 'sampleStepOne', 'sampleResetSteps']
      .forEach(fn => this[fn] = this[fn].bind(this));
  }

  _addEvents() {
    this.dom.colors.forEach((color, i) => {
      color.addEventListener("click", () => {

        if (this.dom.removeableBtn && color.getAttribute("data-removable-id")) {
          this.dom.removeableBtn.setAttribute("data-id", color.getAttribute("data-removable-id"));
        }

        if (this.dom.traditionalBtn && color.getAttribute("data-traditional-id")) {
          this.dom.traditionalBtn.setAttribute("data-id", color.getAttribute("data-traditional-id"));
        }

        if (this.dom.grassclothBtn && color.getAttribute("data-grasscloth-id")) {
          this.dom.grassclothBtn.setAttribute("data-id", color.getAttribute("data-grasscloth-id"));
        }

        this.changeImage(i);
      }, false)
    });

    if (this.dom.addSampleContainer) {

      this.dom.addSampleContainer.addEventListener("click", this.sampleStepOne, false)

      this.dom.sampleButtons.forEach(el => {
        el.classList.add("bound");
        el.addEventListener("click", (e) => { this.addSample(e) })
      });

      this.dom.overlayContainer.querySelectorAll(".button").forEach(button => {
        button.addEventListener("click", () => {
          button.classList.add("clicked");
        })
      })

      this.dom.el.addEventListener("mouseleave", this.sampleResetSteps, false)
    }
  }

  _hydrateImage(img) {
    if (!img) return;
    const src = img.getAttribute("data-src");
    if (src) {
      img.setAttribute("src", src);
      img.removeAttribute("data-src");
    }
  }

  changeImage(i) {
    const nextImage = this.dom.images[i];
    const nextColor = this.dom.colors[i];
    if (!nextImage || !nextColor) return;

    this._hydrateImage(nextImage);

    const currentImage = this.dom.el.querySelector(".variant-images img.active")
    if (currentImage) currentImage.classList.remove("active")
    nextImage.classList.add("active")

    const currentColor = this.dom.el.querySelector(".color-container .color.is-selected")
    if (currentColor) currentColor.classList.remove("is-selected")
    nextColor.classList.add("is-selected")

    this._setSampleVariant(this.dom.removeableBtn, nextColor.getAttribute("data-removable-id"));
    this._setSampleVariant(this.dom.traditionalBtn, nextColor.getAttribute("data-traditional-id"));
    this._setSampleVariant(this.dom.grassclothBtn, nextColor.getAttribute("data-grasscloth-id"));
    this._setSampleVariant(this.dom.vinylBtn, nextColor.getAttribute("data-vinyl-id"));

    const variantId = nextColor.getAttribute("data-id");
    if (variantId) {
      this.dom.el.querySelectorAll("a.link-wrapper, .headline-container h1 a").forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set("variant", variantId);
        link.href = `${url.pathname}${url.search}${url.hash}`;
      });
    }
  }

  _setSampleVariant(button, variantId) {
    if (button && variantId) button.setAttribute("data-id", variantId);
  }


  // Add Sample
  sampleStepOne() {
    gsap.set(this.dom.addSampleContainer, { autoAlpha: 0, pointerEvents: "none" })
    gsap.set(this.dom.optionContainer, { autoAlpha: 1, pointerEvents: "all" })
  }

  addSample(e) {
    const id = e.currentTarget?.dataset?.id;
    if (!id) return;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }]
      })
    })
      .then((response) => {
        if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
        if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  sampleResetSteps() {
    gsap.set(this.dom.addSampleContainer, { autoAlpha: 1, pointerEvents: "all", delay: 0.3 })
    gsap.set(this.dom.optionContainer, { autoAlpha: 0, pointerEvents: "none", delay: 0.3 })

    this.dom.overlayContainer.querySelectorAll(".button").forEach(button => {
      button.classList.remove("clicked");
    })
  }
}
